'use client';
import { pushToDataLayer, DataLayerEvent } from 'components/helpers/Global/Analytics/DataLayer';

interface NewsletterAnalyticsParams {
  newsletterTitles: string[];
  newsletterIds: string[];
  subscriberPosition: string;
}

export const sendNewsletterOptInAnalytics = ({
  newsletterTitles,
  newsletterIds,
  subscriberPosition,
}: NewsletterAnalyticsParams): void => {
  const payload: DataLayerEvent = {
    event: 'newsletter_opt_in',
    newsletter_title: newsletterTitles,
    newsletter_id: newsletterIds,
    subscriber_position: subscriberPosition,
  };

  pushToDataLayer(payload);
};

export const sendInterstitialViewAnalytics = ({
  newsletterTitles,
  newsletterIds,
  subscriberPosition,
}: NewsletterAnalyticsParams): void => {
  const payload: DataLayerEvent = {
    event: 'interstitial_view',
    newsletter_title: newsletterTitles,
    newsletter_id: newsletterIds,
    subscriber_position: subscriberPosition,
  };

  pushToDataLayer(payload);
};

export const sendInterstitialCloseAnalytics = ({
  newsletterTitles,
  newsletterIds,
  subscriberPosition,
}: NewsletterAnalyticsParams): void => {
  const payload: DataLayerEvent = {
    event: 'interstitial_close',
    newsletter_title: newsletterTitles,
    newsletter_id: newsletterIds,
    subscriber_position: subscriberPosition,
  };

  pushToDataLayer(payload);
};
